import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63e46640"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "echarts-container" }

import { VNode, ref, Ref, reactive } from 'vue';
import AutoAllocStatisticsEcharts from './componets/AutoAllocStatisticsEcharts.vue';
import { TradeOrderAutoAllocInfoRecordProxy, queryTradeOrderAutoAllocInfoRecordProxyPage } from '../services';
import { ElLoading } from 'element-plus';
import { VxeTableDefines } from 'vxe-table';

interface EchartPropsData {
  inputType: string;
  dateRange: [Date, Date];
  timeUnit: string;
  clickDate?: string | null;
  relationOrderCode?: string | null | any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AutoAllocConsoleHistory',
  props: {
    rowFieldsVNodes: null
  },
  setup(__props: any) {

const props = __props as {
  rowFieldsVNodes: VNode[];
}


const tableRef: Ref<any> = ref(null);
const tabDivRef: Ref<any> = ref(null);
const tableDivRefLoading: Ref<any> = ref(null);
const historyRef: Ref<any> = ref(null);
const historyRefLoading: Ref<any> = ref(null);
const tableHasData: Ref<boolean> = ref(false);
const tableDate: Ref<Date | null> = ref(null);

const clickInfo: {
  nextId?: string | null;
  clickDate?: Date;
  timeUnit?: string;
  relationOrderCode?: string | null | any;
} = {
  timeUnit: 'ONE_MINUTE'
};

const getHistoryData = (
  index?: number | null | undefined
): TradeOrderAutoAllocInfoRecordProxy[] | TradeOrderAutoAllocInfoRecordProxy | null => {
  let tableDataList = tableRef.value ? tableRef.value.getTableData().fullData : null;
  return index ? (tableDataList ? tableDataList[index] : null) : tableDataList;
};

const addHistroyData = async (
  data?: TradeOrderAutoAllocInfoRecordProxy | TradeOrderAutoAllocInfoRecordProxy[] | null
) => {
  if (tableRef.value && data) {
    if (data instanceof Array) {
      for (let i = 0; i < data.length; i++) {
        await tableRef.value.insertAt(data[i], -1);
      }
      if (data.length > 0) {
        clickInfo.nextId = data[data.length - 1].id;
      }
    } else {
      await tableRef.value.insertAt(data, -1);
      clickInfo.nextId = data.id;
    }
    tableHasData.value = true;
  }
};

const clearHistoryData = async () => {
  let historyData: any;
  while ((historyData = getHistoryData()) && historyData.length > 0) {
    tableRef.value && (await tableRef.value.remove(getHistoryData(0)));
  }
  tableHasData.value = false;
  clickInfo.nextId = null;
};

const clickEChartData = async (param: EchartPropsData) => {
  historyRefLoading.value = ElLoading.service({
    target: historyRef.value,
    body: true,
    text: 'Loading...'
  });
  tableDivRefLoading.value = ElLoading.service({
    target: tabDivRef.value,
    body: true,
    text: 'Loading...'
  });
  await clearHistoryData();
  if (!param.clickDate) {
    tableDivRefLoading.value.close();
    tableDivRefLoading.value = null;
    historyRefLoading.value.close();
    historyRefLoading.value = null;
    return;
  }
  clickInfo.clickDate = new Date(param.clickDate);
  clickInfo.timeUnit = param.timeUnit;
  clickInfo.nextId = null;
  clickInfo.relationOrderCode = param.relationOrderCode;
  tableDate.value = clickInfo.clickDate;
  const historyListRes = await queryTradeOrderAutoAllocInfoRecordProxyPage(
    clickInfo.clickDate,
    clickInfo.timeUnit,
    clickInfo.nextId,
    clickInfo.relationOrderCode
  );

  historyListRes && (await addHistroyData(historyListRes as any));
  tableDivRefLoading.value.close();
  tableDivRefLoading.value = null;
  historyRefLoading.value.close();
  historyRefLoading.value = null;
};

const scrollHistroyTable = (e: VxeTableDefines.ScrollEventParams): void => {
  if (e.scrollTop + e.bodyHeight + 50 >= e.scrollHeight && !tableDivRefLoading.value) {
    tableDivRefLoading.value = ElLoading.service({
      target: tabDivRef.value,
      body: true,
      text: 'Loading...'
    });
    queryTradeOrderAutoAllocInfoRecordProxyPage(
      clickInfo.clickDate,
      clickInfo.timeUnit,
      clickInfo.nextId,
      clickInfo.relationOrderCode
    )
      .then((res) => {
        addHistroyData(res).then(() => {
          tableDivRefLoading.value.close();
          tableDivRefLoading.value = null;
        });
      })
      .catch((err) => {
        tableDivRefLoading.value.close();
        tableDivRefLoading.value = null;
      });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_vxe_table_column = _resolveComponent("vxe-table-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: "console-history-main",
    ref_key: "historyRef",
    ref: historyRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AutoAllocStatisticsEcharts, { clickData: clickEChartData })
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "table-container",
      ref_key: "tabDivRef",
      ref: tabDivRef
    }, [
      _createVNode(_component_vxe_table, {
        data: reactive([]),
        "max-height": "400",
        ref_key: "tableRef",
        ref: tableRef,
        class: "body-table-scrollbar",
        onScroll: scrollHistroyTable
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_table_column, {
            type: "seq",
            width: "60",
            title: "序号"
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rowFieldsVNodes, (field, index) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(field), { key: index }))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"])
    ], 512), [
      [_vShow, tableDate.value != null]
    ])
  ], 512))
}
}

})